import { login, logout } from '@/api/login'
import Cookies from 'js-cookie'

const state = {
  token: Cookies.get('token'),
  phone: '',
  qx: 0
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },

  SET_USER: (state, user) => {
    state.phone = user.phone
    state.qx = user.qx
  }
}

const actions = {
  Login ({ commit }, user) {
    return new Promise((resolve, reject) => {
      login(user.phone, user.password).then(response => {
        const data = response.data
        if (data.isOk) {
          console.log('login data=', data)
          Cookies.set('token', data.token)
          commit('SET_TOKEN', data.token)
          commit('SET_USER', data.user)
          resolve()
        } else {
          reject(data.msg)
        }
      }).catch(error => {
        let errMsg = error.message === 'Network Error' ? '网络错误,请检查您的网络是否连通！' : error.message
        reject(errMsg)
      })
    })
  },
  LogOut ({ commit }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        commit('SET_TOKEN', '')
        commit('SET_USER', {
          PHONE: '',
          QX: 0
        })
        Cookies.remove('token')
        resolve()
      }).catch(error => {
        commit('SET_TOKEN', '')
        commit('SET_USER', {
          PHONE: '',
          QX: 0
        })
        Cookies.remove('token')
        reject(error)
      })
    })
  }
}

const getters = {
  phone: state => state.phone,
  bm: state => state.bm,
  token: state => state.token,
  qx: state => state.qx
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js